import { useEffect, useRef, useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

const WARNING_BEFORE_MS = 5 * 60 * 1000

export function SessionExpiryModal() {
  const { fridayToken, extendSession, logout, getTokenExpiry } = useAuth()
  const [showWarning, setShowWarning] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    setShowWarning(false)
    if (!fridayToken) return

    const expiry = getTokenExpiry(fridayToken)
    if (!expiry) return

    const timeUntilWarning = expiry - Date.now() - WARNING_BEFORE_MS
    if (timeUntilWarning <= 0) {
      setShowWarning(true)
      return
    }

    timerRef.current = setTimeout(() => setShowWarning(true), timeUntilWarning)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [fridayToken, getTokenExpiry])

  const handleExtend = async () => {
    setShowWarning(false)
    await extendSession()
  }

  const handleSignOut = () => {
    setShowWarning(false)
    logout()
  }

  return (
    <AlertDialog open={showWarning}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Session expiring soon</AlertDialogTitle>
          <AlertDialogDescription>
            Your session will expire in 5 minutes. Would you like to stay signed in?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleSignOut}>Sign out</AlertDialogCancel>
          <AlertDialogAction onClick={handleExtend}>Stay signed in</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
